import { AudioPlayback } from '@components/ui';
import React, { useCallback } from 'react';

import { useResolveAudioRecording } from '../AudioRecordingsContext';
import { CellRenderer, CellRenderProps, CellValue } from '../types';

const AUDIO_FILE_COL_RE = /audio.?file/i;
const AUDIO_EXT_RE = /\.(wav|m4a|mp3|ogg)$/i;

const isAudioFileName = (value: CellValue): boolean => typeof value === 'string' && AUDIO_EXT_RE.test(value.trim());

const isEmpty = (value: CellValue): boolean => value === null || value === undefined || value === '';

const Cell = ({ value }: CellRenderProps) => {
  const resolve = useResolveAudioRecording();
  const resolveRecording = useCallback(async () => {
    const recording = await resolve!(value as string);
    if (!recording) throw new Error(`Recording not found: ${value}`);
    return recording;
  }, [resolve, value]);

  if (isEmpty(value)) return <span>—</span>;
  if (typeof value !== 'string') return <span>{String(value)}</span>;
  if (!resolve) return <span>{value}</span>;
  return <AudioPlayback resolveRecording={resolveRecording} />;
};

export const audioFileRenderer: CellRenderer = {
  kind: 'audioFile',
  detect: (samples, columnName) => {
    if (!columnName || !AUDIO_FILE_COL_RE.test(columnName)) return false;
    return samples.length > 0 && samples.every(isAudioFileName);
  },
  Compact: Cell,
  Expanded: Cell,
  Full: Cell,
};
